import { Box } from '@/components/Box/Box';
import { PlanLimitsNotifications } from '@/bundle/_MasterAdmin/_BillingPage/ui/PlanLimitsDetailsWidget/PlanLimitsNotifications';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { PlanLimitsDetailsWidgetWrapper } from '@/bundle/_MasterAdmin/_BillingPage/ui/styles';
import { InternalOrganizationBillingDetailsType } from '@/api/v1/organization/internal/getInternalOrganizationBillingDetailsApi';
import { UsersUsageRow } from './PlanLimitsUsageRow/UsersUsageRow';
import { PaymentsUsageRow } from './PlanLimitsUsageRow/PaymentsUsageRow';
import { OverageWiresUsageRow } from './PlanLimitsUsageRow/OverageWiresUsageRow';

type PlanLimitsDetailsWidgetType = {
  billingDetails: InternalOrganizationBillingDetailsType;
};

export const PlanLimitsDetailsWidget = ({ billingDetails }: PlanLimitsDetailsWidgetType) => {
  const { extra_views_bought } = billingDetails;
  const showOverageUsage = extra_views_bought > 0;

  return (
    <PlanLimitsDetailsWidgetWrapper>
      <Typography variant='subTitleSmall' color={COLORS.grey[950]} fontWeight='semibold'>
        Plan Limits and Usage
      </Typography>
      <Box display='flex' flexDirection='column' rowGap='20px'>
        <Box display='flex' flexDirection='column' rowGap='14px'>
          <UsersUsageRow billingDetails={billingDetails} />
          <PaymentsUsageRow billingDetails={billingDetails} />
          {showOverageUsage && <OverageWiresUsageRow billingDetails={billingDetails} />}
        </Box>
        <PlanLimitsNotifications billingDetails={billingDetails} />
      </Box>
    </PlanLimitsDetailsWidgetWrapper>
  );
};
